// composables/useNotificationPoller.ts
import { useGameStateStore } from '~/stores/gameState'
import { AuthExpiredError } from '~/types/errors'

let timer: ReturnType<typeof setTimeout> | null = null

export const useNotificationPoller = () => {
  //   const { $api } = useNuxtApp()
  const api = useApi()
  const gameStateStore = useGameStateStore()
  const authStateStore = useAuthStateStore()

  // ポーリング間隔（通常時）
  const NORMAL_INTERVAL = 10000 // 10秒
  const BACKGROUND_INTERVAL = 30000 // 30秒（タブが非アクティブ時）

  const poll = async () => {
    // セッション切れダイアログが出ている間は API を叩かない (#600)。
    // バックグラウンドで refresh を連打して 401 / Discord ノイズを生むのを防ぐ。
    if (authStateStore.isSessionExpired) {
      stop()
      return
    }

    try {
      const interval = !!document && document.visibilityState === 'visible'
        ? NORMAL_INTERVAL
        : BACKGROUND_INTERVAL

      const res = await api.getGameNotifications()

      if (Array.isArray(res.notifications) && res.notifications.length > 0) {
        // 通知キューへ投入（v-snackbar-queueが自動消費）
        gameStateStore.pushNotifications(res.notifications)
      }

      timer = setTimeout(poll, interval)
    }
    catch (err) {
      if (err instanceof AuthExpiredError) {
        stop()
        return
      }

      console.error('Notification poll failed:', typeof err, err)

      // 失敗しても一定時間後に復帰
      timer = setTimeout(poll, NORMAL_INTERVAL * 2)
    }
  }

  const start = () => {
    if (import.meta.server) return
    // セッション切れ表示中は起動しない (#600)。再ログイン後に reset() されたら再開する。
    if (authStateStore.isSessionExpired) return
    if (!timer) {
      poll()
    }
  }

  const stop = () => {
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
  }

  return { start, stop }
}
